const Block = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-heading text-navy text-2xl font-medium mb-3">{title}</h2>
    <div className="font-body text-navy/65 text-[15px] leading-[1.8] space-y-3">{children}</div>
  </section>
);

export default function PrivacyPage() {
  const reopenConsent = () => {
    localStorage.removeItem("cookie_consent");
    window.location.href = "/";
  };

  return (
    <main data-testid="privacy-page" className="min-h-screen bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <a href="/" className="font-body text-gold text-xs tracking-[0.25em] uppercase" data-testid="privacy-back-link">← Voltar ao site</a>
        <h1 className="font-heading text-navy text-4xl sm:text-5xl font-medium mt-8 mb-4">Política de Privacidade</h1>
        <div className="gold-line mb-12" />

        <Block title="Responsável">
          <p>Este site pertence a Dr. Yago Almeida, cirurgião plástico (CRM-RS 45316). Esta política explica como os dados informados neste site são utilizados, em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).</p>
        </Block>
        <Block title="Dados coletados">
          <p>No formulário de contato coletamos apenas nome, telefone e procedimento de interesse, além da origem do acesso (por exemplo, campanha ou parâmetros de anúncio presentes no link).</p>
          <p>Esses dados são usados exclusivamente para retornar o contato e orientar o agendamento de consulta. Não são vendidos nem compartilhados com plataformas de anúncios.</p>
        </Block>
        <Block title="Cookies e ferramentas de medição">
          <p>Com sua autorização, utilizamos Google Tag Manager, Google Analytics e Meta Pixel para medir acessos e a eficácia de campanhas. Sem consentimento, essas ferramentas não armazenam cookies de análise ou publicidade.</p>
          <p>Você pode alterar sua escolha a qualquer momento.</p>
          <button onClick={reopenConsent} data-testid="privacy-reset-consent-btn" className="border border-navy/20 text-navy font-body text-[11px] tracking-[0.1em] uppercase px-6 py-2.5 hover:bg-navy/5 transition-colors duration-300">
            Alterar preferências de cookies
          </button>
        </Block>
        <Block title="Seus direitos">
          <p>Você pode solicitar acesso, correção ou exclusão dos seus dados entrando em contato pelo WhatsApp/telefone (51) 99741-0236.</p>
        </Block>
      </div>
    </main>
  );
}
